var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rr",attrs:{"id":"dd"}},[_c('p',{attrs:{"id":"p"}},[_vm._v("test")]),_c('svg',{attrs:{"width":"500","height":"270"}},[_c('g',{staticStyle:{"transform":"translate(0, 10px)"}},[_c('path',{attrs:{"d":_vm.line}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }